import React
						from 'react';
import {
	Button,
	ButtonGroup,
	Card,
	CardBody,
	CardHeader,
	CardTitle,
	Col,
	Dropdown,
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
	Row
}                       from 'reactstrap';
import TimeframePicker
						from 'components/Charts/TimeframePicker';
import classNames
						from 'classnames';
import MarketingChart   from "components/Charts/MarketingChart";
import { chartService } from '../services';
import SuppliersList from 'components/Suppliers/SuppliersList';
import moment
						from 'moment';
import Collapse
						from 'reactstrap/es/Collapse';

const MAX_CHARTS = 5;

class MarketingDashboard extends React.Component {

	constructor(props) {
		super(props);
		var ds = new Date()
		ds.setHours(0);
		ds.setMinutes(0);
		ds.setSeconds(0);
		var de = new Date();
		de.setHours(23);
		de.setMinutes(59);
		de.setSeconds(59);
		this.state = {
			dropDowns: {
				facebook: {
					open: false,
					selected: ''
				},
				google: {
					open: false,
					selected:''
				},
				suppliers: {
					open: false,
					selected: 'All Sources'
				},
				organic: {
					open: false,
					selected: 'All Sources'
				}
			},
			allData: [],
			facebookData: [],
			supplierData: [],
			organicData: [],
			googleData: [],
			DateStart: ds,
			DateEnd: de,
			Interval: "daily",
			supplierOpen: false,
			supplierList: [],
			hasLoadedData: false,
			fetchedData: MAX_CHARTS
		};
		this.formatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'AUD',
		});
		this.organicSources = [
			{
				Name: 'Inbound Call',
				LeadSourceID: 678
			},
			{
				Name: 'Inbound Web',
				LeadSourceID: 230,
			},
			{
				Name: 'Referral',
				LeadSourceID: 228,
			},
			{
				Name: 'Self Generated',
				LeadSourceID: 190,
			},
			{
				Name: 'Costco Kiosk',
				LeadSourceID: 543,
			},
			{
				Name: 'ASQ',
				LeadSourceID: 40,
			},
			{
				Name: 'Facebook',
				LeadSourceID: 89
			}
		]
	}

	onUpdateChart = (obj) => {
		this.setState({DateStart: obj.start, DateEnd: obj.end, Interval: obj.interval}, this.refreshChartData)
	}

	componentDidMount() {
		chartService.getSuppliers().then(response => {
			this.setState({supplierList: response})
		})
	}

	refreshChartData = () => {
		const {DateStart, DateEnd, Interval} = this.state;
		this.setState({fetchedData: 0})
		var i = 1;
		switch(Interval) {
			case 'weekly':
				i = 7;
				break;
			case 'monthly':
				i = 31;
				break;
		}
		chartService.getFacebook(moment(DateStart).format('YYYY-MM-DD 00:00:00+10'), moment(DateEnd).format('YYYY-MM-DD 23:59:59+10'), i).then(resp => {
			this.setState({facebookData: resp, fetchedData: this.state.fetchedData + 1});
		});
		chartService.getAllMarketingData(moment(DateStart).format('YYYY-MM-DD 00:00:00+10'), moment(DateEnd).format('YYYY-MM-DD 23:59:59+10'), i).then(resp => {
			this.setState({allData: resp, fetchedData: this.state.fetchedData + 1});
		});
		chartService.getGoogleData(moment(DateStart).format('YYYY-MM-DD 00:00:00+10'), moment(DateEnd).format('YYYY-MM-DD 23:59:59+10'), i).then(resp => {
			this.setState({googleData: resp, fetchedData: this.state.fetchedData + 1});
		});
		this.setState({hasLoadedData: true})
		this.getSupplierData();
		this.getOrganicData();
	}

	getOrganicData = () => {
		const {DateStart, DateEnd, Interval} = this.state;
		var i = 1;
		switch(Interval) {
			case 'weekly':
				i = 7;
				break;
			case 'monthly':
				i = 31;
				break;
		}
		//get the id of whoever it is we are looking for
		var who = 'all';
		if (this.state.dropDowns.organic.selected !== 'All Sources') {
			const sup = this.organicSources.find(s => s.Name == this.state.dropDowns.organic.selected);
			who = sup.LeadSourceID
		}
		chartService.getOrganicData(moment(DateStart).format('YYYY-MM-DD 00:00:00+10'), moment(DateEnd).format('YYYY-MM-DD 23:59:59+10'), i, who).then(resp => {
			this.setState({organicData: resp, fetchedData: this.state.fetchedData + 1});
		});
	}

	getSupplierData = () => {
		const {DateStart, DateEnd, Interval} = this.state;
		var i = 1;
		switch(Interval) {
			case 'weekly':
				i = 7;
				break;
			case 'monthly':
				i = 31;
				break;
		}
		//get the id of whoever it is we are looking for
		var who = 'all';
		if (this.state.dropDowns.suppliers.selected !== 'All Sources') {
			const sup = this.state.supplierList.find(s => s.Name == this.state.dropDowns.suppliers.selected);
			who = sup.SupplierID
		}
		chartService.getSupplierData(moment(DateStart).format('YYYY-MM-DD 00:00:00+10'), moment(DateEnd).format('YYYY-MM-DD 23:59:59+10'), i, who).then(resp => {
			this.setState({supplierData: resp, fetchedData: this.state.fetchedData + 1});
		});
	}

	toggleSelect = (graph) => {
		var { dropDowns } = this.state;
		dropDowns[graph].open = !dropDowns[graph].open;
		this.setState(dropDowns);
	}

	leadSourceSelect = (graph, selection) => {
		var { dropDowns } = this.state;
		dropDowns[graph].selected = selection;
		this.setState(dropDowns);
		if (graph == 'suppliers' && this.state.hasLoadedData) {
			this.getSupplierData();
			return;
		}
		if (graph == 'organic' && this.state.hasLoadedData) {
			this.getOrganicData();
			return;
		}
	}

	getSpendTotal = (data) => {
		if (data.length === 0) {
			return '';
		}
		var v = data.reduce((a, b) => (a + b.SpendTotal), 0);
		return this.formatter.format(v);
	}

	getRevenueTotal = (data) => {
		if (data.length === 0) {
			return '';
		}
		var v = data.reduce((a, b) => (a + b.RevenueTotal), 0);
		return "("+this.formatter.format(v)+")";
	}

	toggleSupplier = () => {
		const {supplierOpen} = this.state;
		this.setState({supplierOpen: !supplierOpen})
	}


	render() {
		const { dropDowns, DateStart, DateEnd, Interval,
			facebookData, supplierData, supplierOpen, supplierList,
		organicData,allData, googleData } = this.state;
		const sortClass = supplierOpen ? 'fa-sort-up' : 'fa-sort-down';
		return (
			<>
				<div className="content">
					<Row>
						<Col xs={12}>
							<Card>
								<CardHeader>
									<h4>Reporting
										Timeframe</h4>
								</CardHeader>
								<CardBody>
									<TimeframePicker disabled={this.state.fetchedData != MAX_CHARTS} intervals={["daily", "weekly", "monthly"]} onUpdateChart={this.onUpdateChart}/>
								</CardBody>
							</Card>
						</Col>
					</Row>
					<Row>
						<Col xs={12}>
							<Card>
								<CardHeader className={`toggle-header`} onClick={this.toggleSupplier}>
									<h4>Suppliers <i className={`fas ${sortClass}`}></i></h4>
								</CardHeader>
								<Collapse isOpen={supplierOpen}>
									<CardBody>
										<SuppliersList suppliers={supplierList} />
									</CardBody>
								</Collapse>
							</Card>
						</Col>
					</Row>
					<Row>
						{/* ALL CHART */}
						<Col xs="12">
							<Card className="card-chart">
								<CardHeader>
									<Row>
										<Col className="text-left" sm="6">
											<h5 className="card-category">
												All (Excluding Google Discovery)
											</h5>
											<CardTitle tag="h2">{this.getSpendTotal(allData)} {this.getRevenueTotal(allData)}</CardTitle>
										</Col>
									</Row>
								</CardHeader>
								<CardBody>
									<div>
										<MarketingChart data={allData} interval={Interval} dateStart={DateStart} dateEnd={DateEnd}/>
									</div>
								</CardBody>
							</Card>
						</Col>
					</Row>
					<Row>
						{/* FACEBOOK CHART */}
						<Col xs="12">
							<Card className="card-chart">
								<CardHeader>
									<Row>
										<Col className="text-left" sm="6">
											<h5 className="card-category">
												Facebook
											</h5>
											<CardTitle tag="h2">{this.getSpendTotal(facebookData)} {this.getRevenueTotal(facebookData)}</CardTitle>
										</Col>
									</Row>
								</CardHeader>
								<CardBody>
									<div>
										<MarketingChart data={facebookData} interval={Interval} dateStart={DateStart} dateEnd={DateEnd}/>
									</div>
								</CardBody>
							</Card>
						</Col>
					</Row>
					{/* GOOGLE CHART */}
					<Row>
						<Col xs="12">
							<Card className="card-chart">
								<CardHeader>
									<Row>
										<Col className="text-left" sm="6">
											<h5 className="card-category">
												Google Discovery
											</h5>
											<CardTitle tag="h2">{this.getSpendTotal(googleData)} {this.getRevenueTotal(googleData)}</CardTitle>
										</Col>
									</Row>
								</CardHeader>
								<CardBody>
									<div>
										<MarketingChart data={googleData} interval={Interval} dateStart={DateStart} dateEnd={DateEnd}/>
									</div>
								</CardBody>
							</Card>
						</Col>
					</Row>
					{/*SUPPLIER CHART */}
					<Row>
						<Col xs={`12`}>
							<Card className={`card-chart`}>
								<CardHeader>
									<Row>
										<Col className={`text-left`} sm={`6`}>
											<h5 className={`card-category`}>
												Suppliers
											</h5>
											<CardTitle tag={`h2`}>{this.getSpendTotal(supplierData)} {this.getRevenueTotal(supplierData)}</CardTitle>
										</Col>
										<Col sm={2} />
										<Col sm="3">
											<Row>
												<Col xs={12}>
													<Dropdown isOpen={dropDowns['suppliers'].open} toggle={() => this.toggleSelect('suppliers')}>
														<DropdownToggle caret>
															{dropDowns['suppliers'].selected || 'All Sources'}
														</DropdownToggle>
														<DropdownMenu>
															<DropdownItem header>Pick a Lead Source</DropdownItem>
															<DropdownItem key={'All'} onClick={ () => this.leadSourceSelect('suppliers', 'All Sources') }>All Sources</DropdownItem>
															{
																supplierList.map(s => {
																	if (s.Name == dropDowns['suppliers'].selected) {
																		return <DropdownItem key={s.LeadSourceID} disabled>{s.Name}</DropdownItem>

																	}
																	return <DropdownItem key={s.LeadSourceID} onClick={ () => this.leadSourceSelect('suppliers', s.Name) }>{s.Name}</DropdownItem>
																})
															}
														</DropdownMenu>
													</Dropdown>
												</Col>
											</Row>
										</Col>
									</Row>
								</CardHeader>
								<CardBody>
									<div>
										<MarketingChart data={supplierData} interval={Interval} dateStart={DateStart} dateEnd={DateEnd} />
									</div>
								</CardBody>
							</Card>
						</Col>
					</Row>

					{/*ORGANIC CHART */}
					<Row>
						<Col xs={`12`}>
							<Card className={`card-chart`}>
								<CardHeader>
									<Row>
										<Col className={`text-left`} sm={`6`}>
											<h5 className={`card-category`}>
												Organic
											</h5>
											<CardTitle tag={`h2`}>{this.getSpendTotal(organicData)} {this.getRevenueTotal(organicData)}</CardTitle>
										</Col>
										<Col sm={2} />
										<Col sm="3">
											<Row>
												<Col xs={12}>
													<Dropdown isOpen={dropDowns['organic'].open} toggle={() => this.toggleSelect('organic')}>
														<DropdownToggle caret>
															{dropDowns['organic'].selected || 'All Sources'}
														</DropdownToggle>
														<DropdownMenu>
															<DropdownItem header>Pick a Lead Source</DropdownItem>
															<DropdownItem key={'All'} onClick={ () => this.leadSourceSelect('organic', 'All Sources') }>All Sources</DropdownItem>
															{
																this.organicSources.map(s => {
																	if (s.Name == dropDowns['organic'].selected) {
																		return <DropdownItem key={s.LeadSourceID} disabled>{s.Name}</DropdownItem>

																	}
																	return <DropdownItem key={s.LeadSourceID} onClick={ () => this.leadSourceSelect('organic', s.Name) }>{s.Name}</DropdownItem>
																})
															}
														</DropdownMenu>
													</Dropdown>
												</Col>
											</Row>
										</Col>
									</Row>
								</CardHeader>
								<CardBody>
									<div>
										<MarketingChart data={organicData} interval={Interval} dateStart={DateStart} dateEnd={DateEnd} />
									</div>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</div>
			</>
		);
	}
}

export default MarketingDashboard;